import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAppSelector } from "../../../../../redux/hooks";

function CurrentOrgActivity() {
  const orgId = useAppSelector((state) => state.user.organization_id);
  if (!orgId) return null;
  return <Navigate to="/user/staff/user-activity/$org_id" params={{ org_id: orgId }} replace />;
}

export const Route = createFileRoute("/_authenticated/user/staff/user-activity/")({
  component: CurrentOrgActivity,
});
